import {Card, CardContent, Typography} from "@mui/material";
import React from "react";
import {NumericFormat} from "react-number-format";

export const AggregateCard = ({title, value, unit}) => {
    return(
        <Card sx={{ width: "12rem", marginRight: "2rem", marginBottom: "2rem"}}>
            <CardContent>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="h5" component="div">
                    <NumericFormat displayType="text" value={value} thousandSeparator=" " decimalScale={2} suffix={" "+unit}/>
                </Typography>
            </CardContent>
        </Card>
    )
}